import { render, staticRenderFns } from "./management-mode.vue?vue&type=template&id=2131a3b8&scoped=true&"
import script from "./management-mode.vue?vue&type=script&lang=ts&"
export * from "./management-mode.vue?vue&type=script&lang=ts&"
import style0 from "./management-mode.vue?vue&type=style&index=0&id=2131a3b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2131a3b8",
  null
  
)

export default component.exports